/* Homepage v2, "09 Bags, backpacks and the small things" (sections/ez-shelf-tabs.liquid).
   Tabs and rails are user driven only: a shelf a shopper is reading never switches or scrolls on a timer, so
   there is no mover and no pause pill here. Tabs follow the ARIA tabs pattern (click, left and right arrows,
   Home, End); the closed tabs' card images carry only data-src until their tab opens (EZH.warm). The round
   prev and next buttons scroll the open rail two cards, smoothly, or instantly under reduced motion, and are
   aria-disabled (dimmed, still focusable) at either end. Uses window.EZH from assets/ez-home.js when it is there, and works without it. */
(function () {
  'use strict';

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return window.EZH ? window.EZH.reduced : !!(mq && mq.matches); }
  function warm(img) {
    if (window.EZH && window.EZH.warm) { window.EZH.warm(img); return; }
    if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
    if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
  }

  function setup(root) {
    if (!root || root.__ezShelf) return;
    root.__ezShelf = true;
    var tabs = [].slice.call(root.querySelectorAll('[data-ez-shelf-tab]'));
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    var prev = root.querySelector('[data-ez-shelf-go="-1"]');
    var next = root.querySelector('[data-ez-shelf-go="1"]');
    var cur = Math.max(0, tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; }));

    function rail() { var p = panels[cur]; return p ? p.querySelector('[data-ez-shelf-rail]') : null; }

    var raf = 0;
    function sync() {
      raf = 0;
      var r = rail();
      if (!prev || !next) return;
      // aria-disabled rather than disabled: a button disabled while it has focus drops focus to <body>
      var max = r ? r.scrollWidth - r.clientWidth : 0;
      prev.setAttribute('aria-disabled', !r || r.scrollLeft <= 2 ? 'true' : 'false');
      next.setAttribute('aria-disabled', !r || r.scrollLeft >= max - 2 ? 'true' : 'false');
    }
    function later() { if (!raf) raf = requestAnimationFrame(sync); }

    function select(k, focus) {
      if (k < 0 || k >= tabs.length) return;
      cur = k;
      tabs.forEach(function (t, j) {
        var on = j === k;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, j) {
        if (!p) return;
        if (j === k) [].forEach.call(p.querySelectorAll('img[data-src], img[data-srcset]'), warm);
        p.hidden = j !== k;
      });
      var r = rail();
      if (r) r.scrollLeft = 0;
      if (focus) tabs[k].focus({ preventScroll: true });
      // keep the chosen pill whole inside the phone's sideways tab strip (a tap on a half hidden pill slides it in)
      var strip = tabs[k].parentNode, tb = tabs[k];
      if (strip.scrollWidth > strip.clientWidth) {
        var sr = strip.getBoundingClientRect(), br = tb.getBoundingClientRect(), pad = 20, to = null;
        if (br.left < sr.left + pad) to = strip.scrollLeft + br.left - sr.left - pad;
        else if (br.right > sr.right - pad) to = strip.scrollLeft + br.right - sr.right + pad;
        if (to !== null) strip.scrollTo({ left: to, behavior: reduced() ? 'auto' : 'smooth' });
      }
      sync();
    }

    tabs.forEach(function (t, j) {
      t.addEventListener('click', function () { select(j, false); });
      t.addEventListener('keydown', function (e) {
        var k = -1;
        if (e.key === 'ArrowRight') k = (j + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') k = (j - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') k = 0;
        else if (e.key === 'End') k = tabs.length - 1;
        if (k < 0) return;
        e.preventDefault();
        select(k, true);
      });
    });

    [prev, next].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        var r = rail();
        if (!r || b.getAttribute('aria-disabled') === 'true') return;
        var card = r.firstElementChild;
        var gap = parseFloat(getComputedStyle(r).columnGap) || 20;
        var step = card ? (card.getBoundingClientRect().width + gap) * 2 : r.clientWidth * 0.8;
        r.scrollBy({ left: +b.getAttribute('data-ez-shelf-go') * step, behavior: reduced() ? 'auto' : 'smooth' });
      });
    });

    panels.forEach(function (p) {
      var r = p && p.querySelector('[data-ez-shelf-rail]');
      if (r) r.addEventListener('scroll', later, { passive: true });
    });
    window.addEventListener('resize', later, { passive: true });

    // theme editor: selecting a tab block opens that tab
    root.__ezShelfSelect = function (el) {
      var k = tabs.indexOf(el);
      if (k > -1) select(k, false);
    };

    sync();
  }

  function init(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-ez-shelf]'), setup);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-ez-shelf]');
    if (root && root.__ezShelfSelect) root.__ezShelfSelect(e.target);
  });
})();
